var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWorkspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.678,
    x2: 464.678,
    xlinkHref: "#lg1",
    y1: 115.276,
    y2: 143.973
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.846,
    x2: 455.137,
    xlinkHref: "#lg2",
    y1: 129.625,
    y2: 129.625
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.682,
    x2: 454.069,
    xlinkHref: "#lg1",
    y1: 112.061,
    y2: 142.448
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.818,
    x2: 439.818,
    xlinkHref: "#lg2",
    y1: 144.558,
    y2: 150.545
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.818,
    x2: 439.818,
    xlinkHref: "#lg3",
    y1: 152.494,
    y2: 159.227
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ebac5"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.527,
    x2: 430.527,
    xlinkHref: "#lg4",
    y1: 90.363,
    y2: 105.102
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.818,
    x2: 439.818,
    xlinkHref: "#lg4",
    y1: 90.363,
    y2: 105.102
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.108,
    x2: 449.108,
    xlinkHref: "#lg4",
    y1: 90.363,
    y2: 105.102
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.896,
    x2: 290.838,
    xlinkHref: "#lg3",
    y1: 196.874,
    y2: 402.499
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4605,
    stopColor: "#3a4f4f",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.787,
    x2: 397.658,
    xlinkHref: "#lg5",
    y1: 290.748,
    y2: 290.748
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg5",
    y1: 357.947,
    y2: 390.289
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.721,
    x2: 114.754,
    xlinkHref: "#lg5",
    y1: 290.748,
    y2: 290.748
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.547,
    x2: 30.499,
    xlinkHref: "#lg3",
    y1: 469.931,
    y2: 469.931
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.686,
    x2: 35.045,
    xlinkHref: "#lg1",
    y1: 336.745,
    y2: 336.745
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg1",
    y1: 225.884,
    y2: 328.022
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg2",
    y1: 297.06,
    y2: 326.818
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.09,
    x2: 73.685,
    xlinkHref: "#lg2",
    y1: 302.592,
    y2: 233.778
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg6",
    y1: 242.502,
    y2: 262.93
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(-1 0 0 -1 2323 2711)",
    gradientUnits: "userSpaceOnUse",
    x1: 2250.373,
    x2: 2250.373,
    xlinkHref: "#lg6",
    y1: 2457.023,
    y2: 2467.363
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg1",
    y1: 350.58,
    y2: 452.718
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg2",
    y1: 421.756,
    y2: 451.515
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.09,
    x2: 73.685,
    xlinkHref: "#lg2",
    y1: 427.288,
    y2: 358.474
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 72.627,
    x2: 72.627,
    xlinkHref: "#lg6",
    y1: 367.198,
    y2: 387.626
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 -1 2323 2711)",
    gradientUnits: "userSpaceOnUse",
    x1: 2250.373,
    x2: 2250.373,
    xlinkHref: "#lg6",
    y1: 2332.327,
    y2: 2342.667
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.24,
    x2: 491.192,
    xlinkHref: "#lg3",
    y1: 469.931,
    y2: 469.931
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.379,
    x2: 495.738,
    xlinkHref: "#lg1",
    y1: 336.745,
    y2: 336.745
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 168.185,
    y2: 213.485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.853,
    x2: 381.795,
    y1: 226.196,
    y2: 182.355
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d3326",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d3326"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.114,
    x2: 281.082,
    xlinkHref: "#lg3",
    y1: 48.426,
    y2: 152.897
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.527,
    x2: 285.719,
    y1: 72.837,
    y2: 184.411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 142.517,
    y2: 152.472
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 148.721,
    y2: 141.812
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.338,
    x2: 385.849,
    xlinkHref: "#lg6",
    y1: 153.025,
    y2: 243.537
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46700"
  }))), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg7",
    y1: 239,
    y2: 277.811
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.563,
    x2: 308.444,
    xlinkHref: "#lg7",
    y1: 266.813,
    y2: 205.903
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.961,
    x2: 348.141,
    xlinkHref: "#lg3",
    y1: 184.648,
    y2: 205.829
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(-1 0 0 -1 2790 2591)",
    gradientUnits: "userSpaceOnUse",
    x1: 2447.259,
    x2: 2459.595,
    xlinkHref: "#lg3",
    y1: 2390.572,
    y2: 2402.908
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg1",
    y1: 413.886,
    y2: 445.251
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg1",
    y1: 445.431,
    y2: 413.359
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg3",
    y1: 343.393,
    y2: 362.267
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg3",
    y1: 366.571,
    y2: 385.445
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg3",
    y1: 389.75,
    y2: 408.624
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.933,
    x2: 336.933,
    xlinkHref: "#lg6",
    y1: 315.363,
    y2: 339.081
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.617,
    x2: 342.203,
    xlinkHref: "#lg7",
    y1: 327.402,
    y2: 327.402
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.481,
    x2: 358.388,
    xlinkHref: "#lg3",
    y1: 269.546,
    y2: 269.546
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.625,
    x2: 282.223,
    xlinkHref: "#lg3",
    y1: 452.547,
    y2: 471.146
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.774,
    x2: 277.774,
    xlinkHref: "#lg5",
    y1: 448.774,
    y2: 474.787
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.688,
    x2: 414.286,
    xlinkHref: "#lg3",
    y1: 452.547,
    y2: 471.146
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.837,
    x2: 409.837,
    xlinkHref: "#lg5",
    y1: 448.774,
    y2: 474.787
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464.799 143.973h-10.736v-7.226h10.736c1.802 0 3.269-1.466 3.269-3.269v-7.708c0-1.802-1.466-3.269-3.269-3.269h-10.736v-7.226h10.736c5.787 0 10.495 4.708 10.495 10.495v7.708c0 5.787-4.708 10.495-10.495 10.495z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m475.293 128.694v4.784c0 5.787-4.707 10.496-10.494 10.496h-10.736v-7.226h10.736c1.802 0 3.268-1.468 3.268-3.27v-7.707c0-1.802-1.466-3.268-3.268-3.268h-10.736v-7.226h7.876l-.031.033z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.25 153.059h-14.864c-8.124 0-14.709-6.586-14.709-14.709v-24.154c0-2.993 2.426-5.419 5.419-5.419h33.444c2.993 0 5.419 2.426 5.419 5.419v24.154c0 8.123-6.586 14.709-14.709 14.709z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.686 138.708c.191 7.957 6.697 14.351 14.7 14.351h14.864c8.003 0 14.509-6.393 14.7-14.351z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m460.945 157.427h-42.255c-2.775 0-5.024-2.249-5.024-5.024 0-1.102.894-1.996 1.996-1.996h48.311c1.102 0 1.996.894 1.996 1.996 0 2.775-2.249 5.024-5.024 5.024z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m428.928 105.102c-.541 0-1.082-.206-1.495-.619-.826-.826-.826-2.164 0-2.99l2.175-2.175c.541-.541.541-1.422 0-1.963-1.757-1.757-1.757-4.616 0-6.373.826-.826 2.164-.826 2.99 0s.826 2.164 0 2.99c-.108.108-.108.285 0 .393 2.19 2.19 2.19 5.753 0 7.943l-2.175 2.175c-.413.412-.954.619-1.495.619z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.219 105.102c-.541 0-1.082-.206-1.495-.619-.826-.826-.826-2.164 0-2.99l2.175-2.175c.541-.541.541-1.422 0-1.963-1.757-1.757-1.757-4.616 0-6.373.826-.826 2.164-.826 2.99 0s.826 2.164 0 2.99c-.108.108-.108.285 0 .393 2.19 2.19 2.19 5.753 0 7.943l-2.175 2.175c-.413.412-.954.619-1.495.619z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.509 105.102c-.541 0-1.082-.206-1.495-.619-.826-.826-.826-2.164 0-2.99l2.175-2.175c.541-.541.541-1.422 0-1.963-1.757-1.757-1.757-4.616 0-6.373.826-.826 2.164-.826 2.99 0s.826 2.164 0 2.99c-.108.108-.108.285 0 .393 2.19 2.19 2.19 5.753 0 7.943l-2.175 2.175c-.413.412-.954.619-1.495.619z",
    fill: "url(#SVGID_8_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m23.216 195.878h463.568v189.739h-463.568z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.98 195.878h153.804v189.739h-153.804z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.216 313.746h463.568v71.871h-463.568z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.216 195.878h226.394v189.739h-226.394z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.022 477.882h-6.738c-2.605 0-4.717-2.112-4.717-4.717v-6.468c0-2.605 2.112-4.717 4.717-4.717h6.738c2.605 0 4.717 2.112 4.717 4.717v6.468c0 2.605-2.112 4.717-4.717 4.717z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.481 471.862h-13.655c-4.168 0-7.546-3.379-7.546-7.546v-255.142c0-4.168 3.379-7.546 7.546-7.546h13.655c4.168 0 7.546 3.379 7.546 7.546v255.142c.001 4.168-3.378 7.546-7.546 7.546z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m124.584 326.324h-103.913c-5.739 0-10.391-4.652-10.391-10.391v-103.914c0-5.739 4.652-10.391 10.391-10.391h103.913c5.739 0 10.391 4.652 10.391 10.391v103.913c0 5.739-4.652 10.392-10.391 10.392z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.279 289.992v25.94c0 5.739 4.652 10.391 10.391 10.391h103.913c5.739 0 10.391-4.652 10.391-10.391v-25.94z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.975 315.932v-44.134l-29.942-29.942c-1.311-2.063-3.61-3.436-6.236-3.436h-50.801c-4.081 0-7.389 3.308-7.389 7.389v10.16c0 2.625 1.373 4.925 3.436 6.235l64.118 64.118h16.424c5.738.002 10.39-4.651 10.39-10.39z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.028 262.59h-50.802c-4.081 0-7.389-3.308-7.389-7.389v-10.16c0-4.081 3.308-7.389 7.389-7.389h50.802c4.081 0 7.389 3.308 7.389 7.389v10.16c.001 4.081-3.308 7.389-7.389 7.389z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.573 243.809h42.108c2.571 0 4.655 2.084 4.655 4.655v3.313c0 2.571-2.084 4.655-4.655 4.655h-42.108c-2.571 0-4.655-2.084-4.655-4.655v-3.313c0-2.571 2.085-4.655 4.655-4.655z",
    fill: "url(#SVGID_19_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m124.584 451.02h-103.913c-5.739 0-10.391-4.652-10.391-10.391v-103.914c0-5.739 4.652-10.391 10.391-10.391h103.913c5.739 0 10.391 4.652 10.391 10.391v103.913c0 5.739-4.652 10.392-10.391 10.392z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.279 414.688v25.94c0 5.739 4.652 10.391 10.391 10.391h103.913c5.739 0 10.391-4.652 10.391-10.391v-25.94z",
    fill: "url(#SVGID_21_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m134.975 440.628v-44.134l-29.942-29.942c-1.311-2.063-3.61-3.436-6.236-3.436h-50.801c-4.081 0-7.389 3.308-7.389 7.389v10.16c0 2.625 1.373 4.925 3.436 6.235l64.118 64.118h16.424c5.738.002 10.39-4.651 10.39-10.39z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.028 387.286h-50.802c-4.081 0-7.389-3.308-7.389-7.389v-10.16c0-4.081 3.308-7.389 7.389-7.389h50.802c4.081 0 7.389 3.308 7.389 7.389v10.16c.001 4.081-3.308 7.389-7.389 7.389z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.573 368.505h42.108c2.571 0 4.655 2.084 4.655 4.655v3.313c0 2.571-2.084 4.655-4.655 4.655h-42.108c-2.571 0-4.655-2.084-4.655-4.655v-3.313c0-2.571 2.085-4.655 4.655-4.655z",
    fill: "url(#SVGID_24_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m488.715 477.882h-6.738c-2.605 0-4.717-2.112-4.717-4.717v-6.468c0-2.605 2.112-4.717 4.717-4.717h6.738c2.605 0 4.717 2.112 4.717 4.717v6.468c0 2.605-2.112 4.717-4.717 4.717z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.174 471.862h-13.655c-4.168 0-7.546-3.379-7.546-7.546v-255.142c0-4.168 3.379-7.546 7.546-7.546h13.655c4.168 0 7.546 3.379 7.546 7.546v255.142c.001 4.168-3.378 7.546-7.546 7.546z",
    fill: "url(#SVGID_26_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m502.473 212.732h-494.946c-4.157 0-7.527-3.37-7.527-7.527v-40.251c0-4.157 3.37-7.527 7.527-7.527h494.946c4.157 0 7.527 3.37 7.527 7.527v40.251c0 4.157-3.37 7.527-7.527 7.527z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.771 212.732h-126.823v-55.305h71.519z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m339.389 32.118h-168.778c-3.697 0-6.694 2.997-6.694 6.694v113.579h182.166v-113.579c0-3.697-2.997-6.694-6.694-6.694z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.889 43.511h-147.778c-3.45 0-6.248 2.797-6.248 6.248v84.992c0 3.45 2.797 6.248 6.248 6.248h147.777c3.45 0 6.248-2.797 6.248-6.248v-84.992c0-3.451-2.797-6.248-6.247-6.248z",
    fill: "url(#SVGID_30_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.081 157.427h-200.162c-3.636 0-6.584-2.948-6.584-6.584v-3.951c0-3.636 2.948-6.584 6.584-6.584h200.163c3.636 0 6.584 2.948 6.584 6.584v3.951c0 3.636-2.948 6.584-6.585 6.584z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.465 140.308h21.07c2.182 0 3.951 1.769 3.951 3.951 0 2.182-1.769 3.951-3.951 3.951h-21.07c-2.182 0-3.951-1.769-3.951-3.951.001-2.183 1.769-3.951 3.951-3.951z",
    fill: "url(#SVGID_32_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m377.36 284.638h-80.855c-24.709 0-44.74-20.031-44.74-44.74v-90.557c0-24.709 20.031-44.74 44.74-44.74h80.855c24.709 0 44.74 20.031 44.74 44.74v90.557c0 24.71-20.031 44.74-44.74 44.74z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.766 203.784v36.115c0 24.709 20.031 44.74 44.74 44.74h80.855c24.709 0 44.74-20.031 44.74-44.74v-36.115z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.36 284.638c24.709 0 44.74-20.031 44.74-44.74v-16.97l-54.351-54.351c-3.118-4.339-8.196-7.175-13.946-7.175h-31.046c-9.487 0-17.178 7.691-17.178 17.179v34.771c0 5.759 2.839 10.843 7.19 13.954 1.095 1.517 8.592 8.817 8.981 9.254v48.078z",
    fill: "url(#SVGID_35_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.456 229.184h-31.046c-9.487 0-17.179-7.691-17.179-17.179v-34.771c0-9.487 7.691-17.179 17.179-17.179h31.046c9.487 0 17.179 7.691 17.179 17.179v34.771c-.001 9.488-7.692 17.179-17.179 17.179z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.892 174.489h18.081c5.526 0 10.005 4.479 10.005 10.005v20.251c0 5.526-4.479 10.005-10.005 10.005h-18.081c-5.526 0-10.005-4.479-10.005-10.005v-20.251c0-5.525 4.48-10.005 10.005-10.005z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m413.477 462.809h-23.826v-17.79c0-6.043-4.916-10.96-10.96-10.96h-83.518c-6.043 0-10.96 4.916-10.96 10.96v17.79h-23.826v-17.79c0-19.181 15.605-34.785 34.785-34.785h83.518c19.181 0 34.785 15.605 34.785 34.785v17.79z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.313 419.747h-76.76c-16.836 0-30.533 15.605-30.533 34.785v8.277h16.194v-17.79c0-6.043 4.916-10.96 10.96-10.96h83.518c6.043 0 10.96 4.916 10.96 10.96v17.79h16.194v-8.277c-.001-19.18-13.698-34.785-30.533-34.785z",
    fill: "url(#SVGID_39_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m357.147 363.876h-40.427c-6.401 0-11.589-5.189-11.589-11.589 0-6.401 5.189-11.589 11.589-11.589h40.427c6.401 0 11.589 5.189 11.589 11.589 0 6.401-5.189 11.589-11.589 11.589z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.147 387.055h-40.427c-6.401 0-11.589-5.189-11.589-11.589 0-6.401 5.189-11.589 11.589-11.589h40.427c6.401 0 11.589 5.189 11.589 11.589 0 6.4-5.189 11.589-11.589 11.589z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.147 410.233h-40.427c-6.401 0-11.589-5.189-11.589-11.589 0-6.401 5.189-11.589 11.589-11.589h40.427c6.401 0 11.589 5.189 11.589 11.589 0 6.4-5.189 11.589-11.589 11.589z",
    fill: "url(#SVGID_42_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.897 346.088h-173.928c-10.32 0-18.686-8.366-18.686-18.686 0-10.32 8.366-18.686 18.686-18.686h173.928c10.32 0 18.686 8.366 18.686 18.686 0 10.32-8.366 18.686-18.686 18.686z",
    fill: "url(#SVGID_43_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.897 346.088h-88.581v-37.373h88.581c10.32 0 18.686 8.366 18.686 18.686 0 10.321-8.366 18.687-18.686 18.687z",
    fill: "url(#SVGID_44_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m336.933 353.275c-9.129 0-16.53-7.401-16.53-16.53v-134.399c0-9.129 7.401-16.53 16.53-16.53 9.129 0 16.53 7.401 16.53 16.53v134.399c0 9.129-7.401 16.53-16.53 16.53z",
    fill: "url(#SVGID_45_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 270.901,
    cy: 459.824,
    fill: "url(#SVGID_46_)",
    r: 18.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.901 441.766c-1.489 0-2.928.2-4.312.54 7.887 1.936 13.745 9.034 13.745 17.518s-5.859 15.581-13.745 17.518c1.384.34 2.823.54 4.312.54 9.973 0 18.058-8.085 18.058-18.058s-8.085-18.058-18.058-18.058z",
    fill: "url(#SVGID_47_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 402.964,
    cy: 459.824,
    fill: "url(#SVGID_48_)",
    r: 18.058
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.964 441.766c-1.489 0-2.928.2-4.312.54 7.887 1.936 13.745 9.034 13.745 17.518s-5.859 15.581-13.745 17.518c1.384.34 2.823.54 4.312.54 9.973 0 18.058-8.085 18.058-18.058s-8.085-18.058-18.058-18.058z",
    fill: "url(#SVGID_49_)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorkspace);
export default __webpack_public_path__ + "static/media/icon-workspace.ef6ef9309663cc2cdee79c6d3451a8ac.svg";
export { ForwardRef as ReactComponent };